
export default class BuildUrl {

    constructor(sitePrefix) {
        this._url = sitePrefix;
        this._firstTime = true;
    }

    // https://stackoverflow.com/questions/21647928/javascript-unicode-string-to-hex
    _hexEncode = function(str){
        var hex, i;
    
        var result = "";
        for (i=0; i<str.length; i++) {
            hex = str.charCodeAt(i).toString(16);
            result += ("000"+hex).slice(-4);
        }
    
        return result
    }    

    add(name,value) {
        // convert it to string
        value = "" + value;
        
        var prefix = this._firstTime ? "?" : "&";
        this._firstTime = false;
        // IMPORTANT: we could devise a lot of schemes to encode the value, but it unless there's a unique way to unescape it, we'd run into trouble
        this._url += prefix + name + "=" + this._hexEncode(value);
        return this;
    }
    get() {
        return this._url;
    }
};



// WEBPACK FOOTER //
// ./src/api/buildUrl.js